/** @format */

import React, { memo } from 'react'
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom'

import { Page } from '../Page'
import styles from './layout.module.css'

const getCurrentCourse = ({ html, js, react, git, redux }) => {
  if (git) return 'git'
  if (html) return 'html'
  if (js) return 'js'
  if (react) return 'react'
  if (redux) return 'redux'

  return false
}

const Empty = () => <div>Hello screen</div>

export const Layout = memo(() => {
  const params = useParams()
  const { url } = useRouteMatch()

  console.log('params', params)

  const currentType = getCurrentCourse({ ...params })
  const module = params[currentType]
  const path = url + '/:' + currentType

  const render = (props) => <Page module={module} {...props} />

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Switch>
          <Route exact path={url} component={Empty} />
          <Route path={path} render={render} />
        </Switch>
      </div>
    </div>
  )
})
